// WHICH SOUNDTRACK should be playing — a pure little state machine (no audio, no DOM, no clock of its own), so it can be tested exactly.
//
//   RELAX  the calm zen track (the default)
//   JUICE  the upbeat track, while the player is hammering the clicker
//
// In AUTO (the default, and it stays on) the music follows the player's play:
//   • relax → juice  as soon as the player has clicked the clicker `clicksNeeded` times (10) within `windowMs` (10 s)
//   • juice → relax  when the clicker has been left alone for `neglectMs` (20 s)
// Pressing a mode button by hand switches to that mode at once and the rules carry on from there: choosing Juice counts as activity (so it
// is not sent straight back to Relax for being idle), choosing Relax forgets the recent clicks (so it takes 10 fresh ones to go back).
// Switching Auto OFF freezes whatever mode the player has chosen. Mute is not this module's business: the logic keeps running while the
// sound is muted, so unmuting always lands on the track the play calls for.

export const MUSIC_RULES = Object.freeze({ clicksNeeded: 10, windowMs: 10_000, neglectMs: 20_000 })

export function createMusicLogic({ rules = MUSIC_RULES, mode = 'relax', auto = true, onChange = () => {} } = {}) {
  let clicks = []        // times of the player's recent clicks (only the last windowMs matter)
  let lastClickAt = null
  const st = { mode, auto }

  const set = (m, why) => { if (st.mode === m) return; st.mode = m; onChange({ mode: m, auto: st.auto, why }) }

  function evaluate(now) {
    if (!st.auto) return
    if (st.mode === 'relax' && clicks.filter((t) => now - t <= rules.windowMs).length >= rules.clicksNeeded) set('juice', 'rapid clicking')
    else if (st.mode === 'juice' && (lastClickAt == null || now - lastClickAt >= rules.neglectMs)) { clicks = []; set('relax', 'clicker neglected') }
  }

  return {
    state: () => ({ ...st, recentClicks: clicks.length, lastClickAt }),
    // the player pressed the clicker
    click(now) {
      clicks.push(now); lastClickAt = now
      clicks = clicks.filter((t) => now - t <= rules.windowMs)
      evaluate(now)
    },
    // call now and then (the player does, every 100 ms): lets "neglected for 20 s" happen while nobody is clicking
    tick(now) { clicks = clicks.filter((t) => now - t <= rules.windowMs); evaluate(now) },
    // the player chose a mode by hand: switch now; Auto stays as it is
    choose(m, now) {
      if (m === 'juice') lastClickAt = now; else clicks = []
      set(m, 'chosen')
    },
    // Auto on: the music follows the play again (starting from the situation as it is right now)
    setAuto(on, now) { st.auto = !!on; onChange({ mode: st.mode, auto: st.auto, why: on ? 'auto on' : 'auto off' }); if (on) evaluate(now) },
  }
}
